import {JwtHelperService} from '@auth0/angular-jwt';

export const  OPCLOC:any[] = ["Tienda de Calle", "Centro Comercial"];

export const OPCCAT:any[] = ["A","AA","AAA"];

export const OPCNEG:any[] = ["BLIND","CROMANTIC","ARUMA"];

// export const PATHLOGIN:string = "http://localhost:5052/login";
// export const PATHIMAGENES:string = "http://localhost:5052/upload";
// export const PATHGRAPHQL:string = "http://localhost:5052/graphql";
// export const VIEWIMAGE:string = "http://localhost:5052/static/";
// export const SOCKETIO:string = "http://localhost:5052";
// export const PATHFOTOSRVG:string = "http://localhost:5052/subirfoto";
// export const VIEWIMAGERVG:string = "http://localhost:5052/staticrvg/";
// //
//
// // // servidor de pruebas
// export const PATHLOGIN:string = "http://siesa-app2.prosalon.e-logika.co:5052/login";
// export const PATHGRAPHQL:string = "http://siesa-app2.prosalon.e-logika.co:5052/graphql";
// export const PATHIMAGENES:string = "http://siesa-app2.prosalon.e-logika.co:5052/upload";
// export const VIEWIMAGE:string = "http://siesa-app2.prosalon.e-logika.co:5052/static/";
// export const SOCKETIO:string = "http://siesa-app2.prosalon.e-logika.co:5052";


// // //servidor productivo
// export const PATHLOGIN:string = "http://siesa-app.prosalon.e-logika.co:5052/login";
// export const PATHGRAPHQL:string = "http://siesa-app.prosalon.e-logika.co:5052/graphql";
// export const PATHIMAGENES:string = "http://siesa-app.prosalon.e-logika.co:5052/upload";
// export const PATHFOTOSRVG:string = "http://siesa-app.prosalon.e-logika.co:5052/subirfoto";
// export const VIEWIMAGE:string = "http://siesa-app.prosalon.e-logika.co:5052/static/";
// export const VIEWIMAGERVG:string = "http://siesa-app.prosalon.e-logika.co:5052/staticrvg/";
// export const SOCKETIO:string = "http://siesa-app.prosalon.e-logika.co:5052";


//servidor azure
export const PATHLOGIN:string = "http://13.65.88.148:8080/login";
export const PATHGRAPHQL:string = "http://13.65.88.148:8080/graphql";
export const PATHIMAGENES:string = "http://13.65.88.148:8080/upload";
export const PATHFOTOSRVG:string = "http://13.65.88.148:8080/subirfoto";
export const VIEWIMAGE:string = "http://13.65.88.148:8080/static/";
export const VIEWIMAGERVG:string = "http://13.65.88.148:8080/staticrvg/";
export const SOCKETIO:string = "http://13.65.88.148:8080";


//espejoQA
// export const PATHLOGIN:string = "http://siesa-app.prosalon.e-logika.co:5053/login";
// export const PATHGRAPHQL:string = "http://siesa-app.prosalon.e-logika.co:5053/graphql";
// export const PATHIMAGENES:string = "http://siesa-app.prosalon.e-logika.co:5053/upload";
// export const VIEWIMAGE:string = "http://siesa-app.prosalon.e-logika.co:5053/static/";
// export const SOCKETIO:string = "http://siesa-app.prosalon.e-logika.co:5053";

export const IDSUPERADMIN:number = 4;

export const jwtHelper:JwtHelperService = new JwtHelperService();

export const PERMISOS:any = {
  CREARUSUARIOS:1,
  EDITARUSUARIOS:2,
  BORRARUSUARIOS:3,
  VERTODASTIENDAS:4,
  VERTIENDASASIG:5,
  CREARMALLA:6,
  EDITARMALLA:7,
  BORRARMALLA:8,
  APROBARMALLA:9,
  SUBIRHORARIOTIENDA:10,
  ACTUALIZARHORARIOEMPLEADO:11,
  SINCRONIZARTIENDA:12,
  EDITARTIENDA:13,
  CARGARPRESUPUESTO:14,
  EDITARPRESUPUESTO:15,
  ADMINTIENDAS:16,
  SUBIRHORARIOS:17,
  ADMINUSUARIOS:18,
  ADMINROLES:19,
  CREARROLES:20,
  EDITARROLES:21,
  BUSQUEDAEMPLEADO:22,
  VERADMIN:23,
  VERMALLAPORCENTAJE:24,
  VERMALLAENPESOS:25,
  ADMINCARGOS:26,
  CREARCARGOS:27,
  EDITARCARGOS:28,
  ADMINGRUPOCARGOS:29,
  CREARGRUPOCARGOS:30,
  EDITARGRUPOCARGOS:31,
  ADMINCOMISIONES:32,
  CREARCOMISIONES:33,
  LIQUIDARCOMISIONES:34,
  VERREPORTES:35,
  EDITARMALLABLOQUEADA:36,
  VERRVG:37,
  VERREPORTEPPTO:38,
  ADMINRVG:39,
  CREARVISITASRVG:40,
  PERMISOSINASIGNAR:41
};
